import React from "react";
import Gallery from "../components/Gallery";

const GalleryPage = () => {
  return (
    <div>
      <Gallery />
    </div>
  );
};

export default GalleryPage;
